import Scrolllama from 'scrollama';

const storyParallaxEls = [...document.querySelectorAll('.c-parallax-content')];

if (storyParallaxEls) {
  storyParallaxEls.forEach(storyParallaxEl => {
    const scrollEls = storyParallaxEl.querySelectorAll(
      '.c-parallax-content__headline, .c-parallax-content__label, .c-parallax-content__btn, .c-parallax-content__additional-content, .c-parallax-content__editor-content, .c-parallax-content__additional-label, .c-parallax-content__image--additional',
    );
    const storyBgImage = storyParallaxEl.querySelector(
      '.c-parallax-content__image:not(.c-parallax-content__image--additional)',
    );

    const storyParallaxScroller = new Scrolllama();
    const storyImageScroller = new Scrolllama();

    storyParallaxScroller
      .setup({
        step: scrollEls,
        offset: 0.75,
      })
      .onStepEnter(res => {
        if (res.direction === 'down') {
          res.element.classList.add('is-visible');
        }
      });

    storyImageScroller
      .setup({
        step: storyBgImage,
        offset: 1,
        progress: true,
      })
      .onStepProgress(res => {
        const { element } = res;
        element.style.opacity = `${res.progress}`;
      });
  });
}



// WEBPACK FOOTER //
// ./src/scripts/modules/storyParallax.js